import Vue from "vue";
import VueRouter from "vue-router";
import DashboardPlugin from "./material-dashboard";

// Plugins
import App from "./App.vue";
import store from "@/storage/store"

//Date Picker plugin
import VCalendar from 'v-calendar';
Vue.use(VCalendar, {
  navVisibility: "focus",
  datePickerShowDayPopover: false,
  //firstDayOfWeek: 0  // Monday
});

//Localization plugin
var Lang = require('vuejs-localization');
Lang.requireAll(require.context('./lang', true, /\.js$/));
Vue.use(Lang);

// to set lang-> this.$lang.setLang('en');




// router setup
import routes from "./routes/routes";

// plugin setup
Vue.use(VueRouter);
Vue.use(DashboardPlugin);

// configure router
const router = new VueRouter({
  mode: 'history',
  routes, // short for routes: routes
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
  linkExactActiveClass: "nav-item active"
});

import { setLastRoute } from '@/storage/memoryStorage';
router.beforeEach((to,from,next) => {

  if (to.name !== "Login"){
    setLastRoute({
      route: to.fullPath
    });
  }

  next();
});


//Plugin sl-vue-tree 
//import './../node_modules/sl-vue-tree/dist/sl-vue-tree-dark.css';
import './../node_modules/sl-vue-tree/dist/sl-vue-tree.js';
import SlVueTree from 'sl-vue-tree'
Vue.use(SlVueTree);

//Plugin copy to clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard);

//Plugin vue-ellipse-progress
import VueEllipseProgress from 'vue-ellipse-progress';
Vue.use(VueEllipseProgress);


//Plugin Vue-drag-resize
import VueDragResize from 'vue-drag-resize'
Vue.component('vue-drag-resize', VueDragResize)



function getCurrentEndpoints() {

  const hostname = window.location.hostname;

 //APPLIEDP
    return {
      API_R: "https://apbroker.appliedp.com/api2-r",
      API_W: "https://apbroker.appliedp.com/api2-w",
      API_WS: "wss://apbroker.appliedp.com/api2-ws",
    };
}

Vue.prototype.$ENDPOINTS = getCurrentEndpoints();


/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: h => h(App),
  store,
  router
});
